import { Component } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

declare const Calendly: any;

@Component({
  selector: 'placeme-meeting',
  templateUrl: './meeting.component.html',
  styleUrls: ['./meeting.component.scss'],
})
export class MeetingComponent {
  constructor(private translateService: TranslateService) {}

  booking(): void {
    this.translateService.get('contact.card.content.calendly').subscribe(url => Calendly.initPopupWidget({ url }));
  }
}
